define('form/upload/uploader',['jquery', 'form/upload/dragdropupload'], function ($, DragDropUpload) {
	
	/**
	 * Script dat combineert DragDropUpload naar 1 queue
	 * 
	 * Inherents DragDrop
	 * Extra Settings
	 * 	showProgress: boolean to show progress or not, if false only callback support
	 * 	progressArea: where to place the progress 
	 * 	onStart : function (fileObj) {} callback for add file to queue
	 * 	onComplete: function (fileObj, result) {} callback for succesvol upload
	 * 
	 *  limit uploads!
	 */
	var Uploader = function (element, args) {
		var $this = this;
		this.settings = {
			script : '',
			extensions : '*.*',
			description : 'Alle bestanden',
			data : {},
			count : 0,
			onEnter : function (event) {
				$(this).addClass('active');
			},
			onLeave : function (event) {
				$(this).removeClass('active');
			},
			progressArea : '',
			showProgress : true,
			onStart : function (fileObj) {},
			onComplete : function (fileObj, result) {},
			
			onFull : function () {},
			
			onlyProgress : false
		};
		$.extend(this.settings, args);
		
		// Static class UploadMethods... Upl
		var Upl = {
			// copy of this.settings
			settings : null,
	
			// queue
			q : [],
	
			// status
			status : {
				completed : 0,
				total : 0
			},
			
			// constructor
			init : function (args) {
				Upl.settings = args;
			},
	
			/**
			 * fileObj
			 * @param fileObj
			 * @returns {String} uploadID_[object index in queue]
			 */
			getID : function (fileObj) {
				fileObj = Upl.getFile(fileObj);
				
				var num = null;
				$.each(Upl.q, function (i, el) {
					if(el.name == fileObj.name) {
						num = i;
					}
				});
	
				return 'uploadID_'+num;
			},
			getFile : function (fileArray) {
				if($.type(fileArray) === 'array') {
					return fileArray[0];
				} else if($.type(fileArray.files) === 'array') {
					return fileArray.files[0];
				} else {
					return fileArray;
				}
			},
			queue : function (event, data) {
				var file = Upl.getFile(data);
				if(Upl.hasSpace()) {
					Upl.q.push(file);
					Upl.status.total++;
					
					Upl.settings.onStart(file);
	
					if(Upl.settings.showProgress) Upl.addBar(file);
					
					return true;
				} else {
					Upl.settings.onFull.call(this);
					
					return false;
				}
			},
			
			hasSpace : function () {
				return Upl.settings.count == 0 || Upl.status.total < Upl.settings.count;
			},
			
			progress : function (event, data) {
				var f = Upl.getFile(data);
				var per = parseInt(data.loaded / f.size * 100, 10)+'%';			
				if(Upl.settings.showProgress) Upl.getBar(f).find('.far').css('width', per).html(per);
			},
			progressAll : function (event, data) {
				if(Upl.settings.showProgress) Upl.updateOverall(parseInt(data.loaded / data.total * 100, 10));
			},
			
			error : function (event, data) {
				if(Upl.settings.showProgress) {
					Upl.getBar(data).addClass('error');
		
					function addError(data, msg) {
						Upl.getBar(data).find('.info').append('<span class="error"> '+msg+'</span>');
					}
					
					var file = data.files[0];
					var isFolder = file.type == "";
					
					if(data.textStatus == undefined) {
						
						if(isFolder) {
							addError(data, 'U kunt geen map uploaden, alleen bestanden');
						} else 
							addError(data, 'Bestandstype onjuist');
					
					} else {
						addError(data, 'Overige foutmelding');
					}
				} else {
					console.log('ERROR', data);
				}
			},
	
			complete : function (event, data) {
				Upl.status.completed++;
	
				// callback
				Upl.settings.onComplete(Upl.getFile(data), data.result == undefined ? data : data.result);
				
				// alleen als progress mag
				if(Upl.settings.showProgress) { 
					var bar = Upl.getBar(data);
					bar.addClass('succes');
					bar.find('.far').css('width', '100%').html('100%');
					Upl.updateOverall();
					
					if(Upl.settings.onlyProgress) {
						bar.fadeOut(500, function () {
							bar.remove();
						});
					}
				}
			},
			completeAll : function (event, data) {
				if(Upl.settings.showProgress) 
					Upl.updateOverall(100);
				
				if(Upl.settings.onlyProgress) {
					var o = $(Upl.settings.progressArea).find('.overall');
					o.css('display', 'none');
				}
			},
	
			reset : function () {
				Upl.q = [];
				Upl.status.completed = 0;
				Upl.status.total = 0;
			},
			_formatFileSize: function (bytes) {
				if (typeof bytes !== 'number') {
					return '';
				}
				if (bytes >= 1000000000) {
					return (bytes / 1000000000).toFixed(2) + ' GB';
				}
				if (bytes >= 1000000) {
					return (bytes / 1000000).toFixed(2) + ' MB';
				}
				return (bytes / 1000).toFixed(2) + ' KB';	
		    },
			updateOverall : function (percentage) {
				var o = $(Upl.settings.progressArea).find('.overall');
				o.css('display','block');
				o.find('.of').html('<span>'+Upl.status.completed+'</span>/'+Upl.status.total);
				o.find('.time').html('n.a.');
				if(typeof percentage == 'number') { 
					o.find('.far').css('width', percentage + '%').html(percentage + '%');
				}
		    },
			
			addBar : function (fileObj) {
				var file = Upl.getFile(fileObj);			
				var html = '<div class="bar" id="'+Upl.getID(file)+'"><div class="info">'+file.name+', <span class="filesize">'+Upl._formatFileSize(file.size)+'</span></div> \
				<div class="progress"><span class="far">0%</span></div> \
				</div>';
				$(Upl.settings.progressArea).append(html);
			},
	
			getBar : function (file) {
				return $('#'+Upl.getID(file));
			}
		};
	
		// Static class init
		Upl.init(this.settings);
		
		// init drag drop
		new DragDropUpload({
			element : element,
			script : this.settings.script,
			extensions : this.settings.extensions,
			data : this.settings.data,
			uploaderParent : Upl,
			count : this.settings.count,
			onEnter : this.settings.onEnter,
			onLeave : this.settings.onLeave
		});
		
		// init
		this.init();
	};
	Uploader.prototype.init = function () {};
	
	return Uploader;
});
